<template>
  <div class="wDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul>
      <li>
        <span>昵称</span>
        <font>{{userData.username}}</font>
      </li>
      <li>
        <span>手机号</span>
        <font>{{userData.phone}}</font>
      </li>
      <li>
        <span>姓名</span>
        <font></font>
      </li>
    </ul>

    <div class="code" @click="getQquey">
      <img src="~assets/images/ScanTicket.jpg" >
      <p>点击扫码绑卡，绑定后请到"入园内使用"</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'scanQRCode'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['scanQRCode'],
              success: function (res) {
                if (res.checkResult.scanQRCode === true) {
                  wx.scanQRCode({
                    desc: 'scanQRCode desc',
                    needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                       
                    }, 
                    fail : function(res) { 
                      console.log(res)
                    } 
                  });
                }else {
                  alert('抱歉，当前客户端版本不支持扫一扫')
                }
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .wDetailApp{
    max-width:640px;
    background:#f1f1f1;
    margin:0 auto;
  }
  .wDetailApp ul{
    background:#fff;
  }
  .wDetailApp ul li{
    display:block;
    width:92%;
    margin:0 auto;
    height:50px;
    border-bottom:solid 1px #f1f1f1;
    line-height:50px;
    font-size:15px;
  }
  .wDetailApp ul li font{
    float:right
  }
  .wDetailApp .code{
    background:#fff;
    width:100%;
    display:block;
    padding:50px 0;
    margin-top:8px
  }
  .wDetailApp .code img{
    display:block;
    width:60%;
    margin:0 auto
  }
  .wDetailApp .code p{
    font-size:14px;
    text-align:center;
    padding-top:10px
  }
  
</style>